export default __webpack_public_path__ + "3260f764b376943c6c06d672d31a7877.svg";